import styled from 'styled-components';
import { FontSizes } from '../../../../common/typography/typography.styles';
import {
  ServicesSubSectionContainer,
  ServicesSubSectionHeader,
} from '../../../services/services-subsection/services-subsection.styles';

export const DeliveryTimePanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 4px 0 8px;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.baseColors.grey5};
  color: ${({ theme }) => theme.colors.baseColors.grey150};

  .delivery-time {
    display: flex;
    align-items: flex-start;
    gap: 6px;

    svg {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }

    p {
      min-width: 0;
      margin: 0;
      font-size: ${FontSizes.normal};
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0.5px;
      overflow-wrap: anywhere;
    }
  }

  .tip-no-label {
    margin-left: 2px;
    display: flex;
    gap: 6px;
    align-items: center;

    &.green {
      color: #39a55b;
    }

    &.red {
      color: #e82a53;
    }

    svg {
      height: 20px;
      width: 16px;
    }

    p {
      font-size: ${FontSizes.normal};
      font-weight: 500;
      line-height: 20px;
    }
  }
`;

export const DeliveryStatusContent = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  visibility: hidden;
  margin-top: 1.2rem;
  transition:
    grid-template-rows 250ms ease,
    opacity 250ms ease,
    visibility 0s 250ms;

  &[data-expanded='true'] {
    grid-template-rows: 1fr;
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
  }

  .status-content-inner {
    min-height: 0;
    overflow: hidden;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const DetailsPanelContainer = styled.section`
  min-width: 0;
  background: ${({ theme }) => theme.colors.namedColors.white};
  border: 1px solid ${({ theme }) => theme.colors.baseColors.grey25};
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.baseColors.grey150};
  font-size: ${FontSizes.medium};
  line-height: 22px;
  letter-spacing: 0.5px;

  .panel-heading {
    margin: 0;
    font: inherit;
    button {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      width: 100%;
      min-height: 48px;
      padding: 0 8px 0 20px;
      border: 0;
      border-radius: 10px;
      background: transparent;
      color: inherit;
      font: inherit;
      font-weight: 700;
      text-align: left;
      cursor: pointer;
      &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.colors.namedColors.focus};
      }
      &[aria-expanded='true'] .panel-chevron {
        transform: rotate(180deg);
      }
    }
  }
  .panel-chevron {
    display: flex;
    padding: 12px;
    flex-shrink: 0;
    transition: transform 250ms ease;
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .panel-region {
    display: grid;
    grid-template-rows: 0fr;
    opacity: 0;
    visibility: hidden;
    transition:
      grid-template-rows 250ms ease,
      opacity 250ms ease,
      visibility 0s 250ms;

    &[data-expanded='true'] {
      grid-template-rows: 1fr;
      opacity: 1;
      visibility: visible;
      transition-delay: 0s;
    }
  }
  .panel-region-inner {
    min-height: 0;
    overflow: hidden;
  }
  @media (prefers-reduced-motion: reduce) {
    .panel-region,
    .panel-chevron {
      transition: none;
    }
  }
  .panel-content,
  .panel-summary,
  .panel-footer {
    border-top: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
    padding: 16px 20px 20px;
    overflow-wrap: anywhere;
  }
  .panel-content > ${ServicesSubSectionContainer} {
    padding: 0;
    border: 0;
    border-radius: 0;
    > ${ServicesSubSectionHeader} {
      display: none;
    }
  }
  .participant-delivery {
    border-top: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
    margin-top: 16px;
    padding-top: 16px;
  }
  .parcel-measures {
    border-top: 1px solid ${({ theme }) => theme.colors.baseColors.grey50};
    margin-top: 16px;
    padding-top: 16px;
  }
  .item-description {
    font-size: ${FontSizes.small};
    line-height: 16px;
    margin-bottom: 8px;
  }
  .payment-summary {
    display: grid;
    gap: 16px;
  }
  .payment-total,
  .payment-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }
  .payment-total strong {
    font-size: ${FontSizes.mediumBig};
    line-height: 30px;
  }
  .payment-status {
    font-size: ${FontSizes.normal};
    color: ${({ theme }) => theme.colors.baseColors.grey100};
  }
  .payment-status span {
    font-size: ${FontSizes.small};
    font-weight: 500;
  }
`;
